export default function ArrowBottomIcon(
  { className }: { className?: string }
) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Select</title>
      <path
        d="M13.0392 16.8572C12.5774 17.6572 11.4227 17.6572 10.9608 16.8572L7.27391 10.4714C6.81203 9.67139 7.38938 8.67139 8.31314 8.67139L15.6869 8.67139C16.6106 8.67139 17.188 9.67139 16.7261 10.4714L13.0392 16.8572Z"
        fill="currentColor"
      />
    </svg>
  );
}
